export default __webpack_public_path__ + "static/logo-1f86bfe72345716e955734100c965373.svg";